import { clearCanvas, normalizeRange, setupCanvas } from './canvas-utils';

export function renderSparklineChart(canvas: HTMLCanvasElement, values: number[], color: string): void {
    const setup = setupCanvas(canvas);
    if (!setup) return;
    const { ctx, width, height } = setup;

    clearCanvas(ctx, width, height);
    if (values.length < 2) return;

    const { min, max } = normalizeRange(values);
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.beginPath();

    values.forEach((v, i) => {
        const x = (i / (values.length - 1)) * width;
        const y = height - ((v - min) / (max - min)) * height;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    });

    ctx.stroke();
}
